import { render, staticRenderFns } from "./ActivityCardSkeleton.vue?vue&type=template&id=34d7d16e&scoped=true&"
var script = {}
import style0 from "./ActivityCardSkeleton.vue?vue&type=style&index=0&id=34d7d16e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34d7d16e",
  null
  
)

export default component.exports